import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Event } from 'crono-fe-common/types/event';
import { QueryErrorMeta } from 'utils/queryClient';

export default function useGetEvent<TData = Event>(
  eventId: number | undefined,
  meta?: QueryErrorMeta,
  select: (data: Response<Event>) => TData = (response) =>
    response.data.data as TData,
) {
  const request: Request = {
    url: `${ENDPOINTS.events.event}?id=${eventId}`,
    config: {
      method: 'get',
    },
  };

  return useQuery<Response<Event>, CronoError, TData>({
    queryKey: [ENDPOINTS.events.event, eventId],
    queryFn: () => client(request),
    enabled: eventId !== undefined,
    select,
    meta,
  });
}
